module.exports = __webpack_public_path__ + "static/media/icn_progress_active.f1140fb9.svg";